import { render, staticRenderFns } from "./OHSEducationCreateOrUpdate.vue?vue&type=template&id=87853400&"
import script from "./OHSEducationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./OHSEducationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports